import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { WellSchematicDiagramService } from 'app/modules/well-schematic-diagram/services/well-schematic-diagram.service';
import { SchematicFormType, WellSchematicDiagram } from 'app/modules/well-schematic-diagram/model';
import module from 'app/modules/well-schematic-diagram/well-schematic-diagram.module';

@Component({
    selector: 'app-dat-form',
    templateUrl: './form.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./form.component.scss'],
})
export class FormComponent {
    isUpdate: boolean = false;
    form: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<FormComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { payload: WellSchematicDiagram; type: SchematicFormType },
        private service: WellSchematicDiagramService,
        private formBuilder: FormBuilder
    ) {}

    ngOnInit() {
        this.isUpdate = false;
        this.setForm();
    }

    setForm() {
        const row = this.data.payload;
        this.form = this.formBuilder.group({
            id: new FormControl({ value: row.id, disabled: false }),
            remark: new FormControl({ value: row.remark, disabled: false }),
            status: new FormControl({ value: row.status, disabled: false }),
        });
    }

    update() {
        this.isUpdate = true;
        const payload = {
            ...this.data.payload,
            ...this.form.value,
        };
        if(this.data.type == "configuration") {
            delete payload.status;
        }
        this.closeDialog(payload);
    }

    closeDialog(payload = null): void {
        this.dialogRef.close({
            payload,
            isUpdate: this.isUpdate
        });
    }
}
